module.exports = __webpack_public_path__ + "img/02n.28d85afb.png";